import React from 'react';

import {
  ScreenAllFilters,
  ScreenFilters,
  ScreenFiltersApply,
} from 'components/Filters';
import { ScreenPresets } from 'components/Presets';

import { Route } from '@gogame/screens';
import { Sentry } from '@gogame/components';
import { Screen, withScreen, createScreenRoute } from '@gogame/screens';

import AllFilters from './Filters/AllFilters';
import PrimaryFilters from './Filters/PrimaryFilters';
import { SmartRuleRouteElement } from './SmartRuleDetails';
import { SmartRulesActionCallback } from './SmartRulesActionCallback';
import { SmartRulesDataTable } from './SmartRulesDataTable';
import SmartRulesTrackerRedirect from './SmartRulesTrackerRedirect';
import { SCREEN_NAME } from './constants';
import {
  smartRulesLink,
  smartRulesDetailsLink,
  smartRulesTrackerRedirectLink,
  smartRulesSearchParams,
  smartRulesActionCallbackLink,
} from './navigation';
import { mapStateToPreset, EMPTY_FILTERS } from './schemas';
import screenReducer from './screenReducer';

const permission = 56;
const id = 46;

const SmartRules = withScreen({
  name: SCREEN_NAME,
  searchParams: smartRulesSearchParams,
  reducer: screenReducer,
})(() => {
  return (
    <React.Fragment>
      <Screen.Toolbar />
      <Screen.Body>
        <ScreenPresets mapStateToPreset={mapStateToPreset} />
        <ScreenFilters emptyValues={EMPTY_FILTERS}>
          <PrimaryFilters />
          <ScreenAllFilters sidePage={AllFilters} />
          <ScreenFiltersApply />
        </ScreenFilters>
        <SmartRulesDataTable />
        <Sentry.Routes>
          <Route
            path={smartRulesDetailsLink.path}
            element={<SmartRuleRouteElement />}
          />
          <Route
            path={smartRulesActionCallbackLink.path}
            element={<SmartRulesActionCallback />}
          />
          <Route
            path={smartRulesTrackerRedirectLink.path}
            element={<SmartRulesTrackerRedirect />}
          />
        </Sentry.Routes>
      </Screen.Body>
    </React.Fragment>
  );
});

export default createScreenRoute({
  id: id,
  permission: permission,
  title: 'Smart Rules',
  link: smartRulesLink,
  screen: <SmartRules />,
  knowledgeBaseUrl:
    'https://go-game.zendesk.com/hc/en-us/sections/360003141794-Smart-Rules',
});
